/**
 * Le thème courant est-il un thème sombre ?
 *
 * À n'appeler que pour ce qu'aucune COULEUR ne peut porter. Six appelants, et ils ont chacun
 * leur raison : `<Logo>`, dont le DESSIN change (le mot « Masteur » est marine sur la version
 * claire, blanc sur la version nuit) ; le surligneur (`atoms/Highlight/useHighlighterBand`),
 * dont la FORME change (la bande monte couvrir le mot) — et, pour la même raison, le trait qui
 * balaie les squelettes (`atoms/Skeleton/SkeletonGroup`) ; `<Glow>`, qui n'existe pas sur la nuit
 * (une couleur d'arrêt transparente ne l'éteint pas sur iOS) ; `<ImageIcon>`, dont le picto se
 * pose sur une pastille claire (un dessin de plus, et le picto rétrécit dedans) ; et
 * `ports/.../useParentStatusBar`, parce que la barre d'état du système ne prend pas une encre
 * mais un mot (`light` / `dark`).
 * Tout le reste se peint par jetons et suit le thème sans rien savoir : un composant qui branche
 * sur le schéma pour choisir une couleur a manqué un jeton.
 *
 * `rt.themeName` est une vraie chaîne des deux côtés, alors qu'une valeur lue dans `theme` sort
 * en variable CSS sur le web et ne se compare pas.
 */
import { useUnistyles } from "react-native-unistyles"

import { isDarkThemeName } from "../theme/scheme"

export function useIsDarkTheme(): boolean {
    const { rt } = useUnistyles()
    return isDarkThemeName(rt.themeName)
}
